export const PrescriptionTypes = Object.freeze({
    0: "Not Specified",
    1: "FP10",
    2: "FP10SS",
    3: "FP10NC",
    4: "FP10HNC",
    5: "FP10MDA-SS",
    6: "FP10MDA-S",
    7: "FP10MDA-SP",
    8: "FP10HMDA",
    9: "FP10D",
    10: "FP10PN",
    11: "FP10SP",
    12: "FP10P-REC",
    13: "FP10CDF",
    14: "FP10PCDSS",
    15: "FP10PCDNC",
    16: "WP10",
    17: "WP10SS",
    18: "WP10SP",
    19: "WP10HP",
    20: "WP10HSP",
    21: "WP10D",
    22: "WP10CN",
    23: "WP10PN",
    24: "WP10MDA",
    25: "WP10HP(AD)",
    26: "WP10MDASS",
    27: "WP10SPSS",
    28: "WP10IPSS",
    29: "GP10",
    30: "GP10SS",
    31: "GP10(N)",
    32: "GP14",
    33: "HBP",
    34: "HBP(A)",
    35: "HS21",
    36: "HS21D",
    37: "HS21M",
    38: "HS21N",
    39: "SP1",
    40: "SP2",
    41: "HS10",
    42: "HS10MDA",
    43: "HS10SS",
    44: "CP2/3",
    45: "CPUS",
    46: "FMed296",
    47: "FP10CDF/WP10DF",
    48: "FP10L",
    49: "FP10PRec",
    50: "GP10A",
    51: "GP10S",
    52: "GP10DTS",
    53: "HOOF",
    54: "HS21S",
    55: "PS6",
    56: "H9",
    57: "FP10PCD-SS",
    58: "FP10PCD-NC",
    59: "WP10PCD",
    60: "WP10PCDSS",
    61: "PPCD(1)",
    62: "OTC Sale",
    63: "Private Master of Ship",
    64: "Vet Cascade",
    65: "Private Midwife",
    66: "Stock Requisition",
    67: "Sale to public",
    68: "Private Prison Supply",
    69: "Emergency Supply",
    70: "FP10CN",
    71: "Smoking Cessation Level 2",
    72: "Smoking Cessation Level 3",
    73: "PGD",
    74: "EHC",
    75: "Choose Pharmacy",
    76: "Private Prescription",
    77: "Vet Clinical",
    78: "Replacement",
    79: "Private Emergency",
    80: "NHS Service Emergency",
    81: "Clozepine",
    82: "Clozepine Blister",
    83: "Named TTO",
});
  
